import { SUPPORT_EMAIL } from "constants/config";

type PropsType = {
  title: string;
  description: string;
  showSupportEmail?: boolean;
};
function DailyLimitReached({
  title,
  description,
  showSupportEmail = false,
}: PropsType) {
  return (
    <section className="flex flex-col px-4 py-3 sm-normal rounded-lg bg-chart-red-faint">
      <h3 className="sm-md">{title}</h3>
      <p>
        {description}

        {showSupportEmail && (
          <>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="underline">
              {SUPPORT_EMAIL}
            </a>
            .
          </>
        )}
      </p>
    </section>
  );
}

export default DailyLimitReached;
